/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type PrivacyLevel = typeof PrivacyLevel[keyof typeof PrivacyLevel];


export const PrivacyLevel = {
  PUBLIC: 'PUBLIC',
  RESTRICTED: 'RESTRICTED',
  UNLISTED: 'UNLISTED',
  PO_ONLY: 'PO_ONLY',
} as const;
